import { WIDGETS } from '../constants';
export var getVisualizationIcon = function (_a) {
    var type = _a.type, chartSettings = _a.chartSettings;
    var activeVisualization = WIDGETS.find(function (_a) {
        var isActive = _a.isActive;
        return isActive(type, chartSettings);
    });
    if (activeVisualization) {
        return activeVisualization.icon;
    }
    var icon = WIDGETS.find(function (_a) {
        var widget = _a.widget;
        return widget === type;
    }).icon;
    return icon;
};
